// Google OAuth Client ID for YouTube integration
// Get this from Google Cloud Console > APIs & Services > Credentials
// Make sure to add your redirect URIs (e.g., http://localhost:3000/, https://toldfel.hu/)
const GOOGLE_CLIENT_ID = '896898621109-hp0c9mrpqp6lr3hfom5e87vrm1csaoc5.apps.googleusercontent.com';

export { GOOGLE_CLIENT_ID };
